import { call, put } from 'redux-saga/effects'
import LinkActions from 'Redux/LinkRedux'
import ApiErrorMessages from './ApiErrorMessages'

export function * onLinksRequest (api, action) {
  const response = yield call(api.getLinks)
  if (response.ok) {
    yield put(LinkActions.linksListSuccess(response.data))
  } else if (ApiErrorMessages[response.problem]) {
    yield put(
      LinkActions.linksListFailure(ApiErrorMessages[response.problem])
    )
  }
}

export function * onCreateLinkRequest (api, action) {
  const response = yield call(api.createLink, action.createParams)
  if (response.ok) {
    yield put(LinkActions.linksCreateSuccess(response.data))
    yield put(LinkActions.linksListRequest())
  } else if (ApiErrorMessages[response.problem]) {
    yield put(
      LinkActions.linksCreateFailure(ApiErrorMessages[response.problem])
    )
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/LinkSagas.js